module.exports = __webpack_public_path__ + "img/api-explorer.e949d254.svg";